import styled from 'styled-components'

import Button from 'components/Button'
import { style } from 'theme'
import { PageLayout } from 'components/templates/PageLayout/PageLayout'

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 10px;
  width: 100%;
`

export const LinkInCTAContainer = styled.div<{ show: boolean }>`
  display: none;
  text-align: center;

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    ${(props) => props.show && 'display: block;'}
    padding: 0 0 10px;
  }
`

export const StyledPageLayout = styled(PageLayout)<{
  isPromoCodeShowing: boolean
}>`
  > div > div {
    padding-top: ${(props) => (props.isPromoCodeShowing ? '0' : '10px')};
  }

  .page-template-content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  > div > div > div:nth-child(3) {
    ${(props) =>
      props.isPromoCodeShowing
        ? ` display: flex;
            flex-direction: column;`
        : ''}
  }
`

export const AcornsHeaderLogo = styled.img`
  height: 26px;
`

export const AcornImage = styled.img`
  object-fit: cover;
`
